enum MenuActionType {
	SET_MENU = "SET_MENU",
}

export default MenuActionType;

